import React, { useState } from 'react';
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContainer,
  MainContent,
  SubTitle,
  Title,
} from '../../../../../components/StyledComponents';
import Input from '../../../../../components/InputControlled';
import TextArea from '../../../../../components/TextArea';
import { useForm } from 'react-hook-form';
import { valueIsRequired } from '../../../../../utils/regex';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { useHistory, useParams } from 'react-router';
import { useEffect } from 'react';
import { useMemo } from 'react';
import Spinner from 'react-spinner-material';
import { UserActionsContent } from '../../../../../components/UserActionsContent';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';

import LogoRelatorio from '../../../../../images/logoRelatorio.png';

export const EditarPerfilUsuario = () => {
  const { id } = useParams();
  console.log('EditarPerfilUsuario', id);
  const [dataEdit, setDataEdit] = useState({});
  const { control, handleSubmit, reset, formState } = useForm({
    defaultValues: useMemo(() => {
      return dataEdit;
    }, [dataEdit]),
  });
  const { isSubmitting } = formState;
  const { showModal } = React.useContext(BaSeDialogContext);

  const history = useHistory();

  const handleGoHome = () => {
    history.push('/reports', { screen: 'PerfilUsuarios' });
  };

  const findTipo = async () => {
    const result = await PerfilUsuarioService.findPerfilById(id);
    setDataEdit(result);
  };

  useEffect(() => {
    findTipo();

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset(dataEdit);

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEdit]);

  const submitForm = async (dataForm) => {
    try {
      dataForm.id = id;
      const response = await PerfilUsuarioService.updatePerfil(dataForm);
      handleModalStatus({
        type: 'success',
        msgOnSuccess: 'Perfil editado com sucesso.',
        onCloseModal: handleGoHome,
        showModal,
      });
      return response;
    } catch (e) {
      handleModalStatus({
        type: 'error',
        showModal,
      });
    }
  };

  return (
    <>
      <MainContainer backgroundColor={'#00ccff'}>
        <FlexDirectionRow>
          <FlexDirectionRow style={{ width: '100%' }}>
            <img
              alt="imagem"
              style={{ width: '2.5rem', height: '2.5rem' }}
              src={LogoRelatorio}
            />
            <Title>Relatórios</Title>
          </FlexDirectionRow>
          <BaSeIcon
            onClick={handleGoHome}
            name={'arrow-circle-left'}
            description="voltar"
            color="#ffffff"
            size={50}
          />
        </FlexDirectionRow>
      </MainContainer>
      <MainContent>
        <SubTitle>
          <h3>Perfil de usuário: Editar</h3>
        </SubTitle>

        <FormContainer>
          <div style={{ flex: 1 }}>
            <Input
              name="nome"
              control={control}
              rules={{ ...valueIsRequired() }}
              placeholder="Nome do perfil"
              maxLength={140}
              borderRadius="6px"
            />
            <TextArea
              name="descricao"
              control={control}
              rules={{ ...valueIsRequired() }}
              placeholder="Descrição"
              borderRadius="6px"
            />
          </div>

          <div style={{ flex: 1, paddingBottom: '1rem' }}>
            <FlexDirectionRow
              position={'end'}
              align={'end'}
              style={{
                marginRight: '40px',
                width: '100%',
                height: '100%',
              }}
            >
              <Button href="#" onClick={handleSubmit(submitForm)}>
                {isSubmitting ? (
                  <Spinner
                    radius={5}
                    color={'#fff'}
                    stroke={2}
                    visible={true}
                  />
                ) : (
                  'Editar Perfil'
                )}
              </Button>
            </FlexDirectionRow>
          </div>
        </FormContainer>
      </MainContent>
      <UserActionsContent data={dataEdit} />
    </>
  );
};
